import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let appSurveyOptions = [];
let subsidiaryOptions = [];

function SubsidiaryAppSurveyTableRow({ index, appSurveyNames, userSubsidiaries, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [appSurveyLoaded, setAppSurveyLoaded] = useState(false);
	const [appSurveySelected, setAppSurveySelected] = useState({ name: "appSurveyKey", label: "", value: 0 });
	const [userSubsidiaryLoaded, setUserSubsidiaryLoaded] = useState(false);
	const [userSubsidiarySelected, setUserSubsidiarySelected] = useState({ name: "subsidiaryKey", label: "", value: 0 });
	const canReadRef = useRef(null);
	const [isCanRead, setIsCanRead] = useState(false);
	const canWriteRef = useRef(null);
	const [isCanWrite, setIsCanWrite] = useState(false);
	const canReviewRef = useRef(null);
	const [isCanReview, setIsCanReview] = useState(false);
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		setAppSurveyValues(appSurveyNames);
		setUserSubsidiaryValues(userSubsidiaries);
	}, []);

	function setAppSurveyValues(appSurveyObj) {
		let appSurveyValue = {};
		appSurveyOptions = [];
		if (appSurveyObj && appSurveyObj.length > 0) {
			appSurveyObj.map((aAppSurvey, idx) => {

				appSurveyValue.label = aAppSurvey.surveyDisplayName;
				appSurveyValue.value = aAppSurvey.appSurveyKey;
				appSurveyOptions.push(appSurveyValue);
				if (idx == 0) {
					setAppSurveySelected({ ...appSurveySelected, label: (appSurveyValue.label), value: aAppSurvey.appSurveyKey });
				}
				appSurveyValue = {};
			});
			setAppSurveyLoaded(true);
		}
	}
	const appSurveyHandler = (selectedOption, action) => {
		let appSurveyKey = selectedOption ? selectedOption.value : 0;
		let appSurveyLabel = selectedOption ? selectedOption.label : "";
		setAppSurveySelected({ ...appSurveySelected, label: (appSurveyLabel), value: appSurveyKey });
	}
	function setUserSubsidiaryValues(subsidiaryObj) {
		let subsidiaryValue = {};
		subsidiaryOptions = [];
		if (subsidiaryObj && subsidiaryObj.length > 0) {
			subsidiaryObj.map((aSubsidiary, idx) => {

				subsidiaryValue.label = aSubsidiary.companyName;
				subsidiaryValue.value = aSubsidiary.companyId;
				subsidiaryOptions.push(subsidiaryValue);
				subsidiaryValue = {};
			});
			setUserSubsidiaryLoaded(true);
		}
	}
	const subsidiaryHandler = (selectedOption, action) => {
		let subsidiaryKey = selectedOption ? selectedOption.value : 0;
		let subsidiaryLabel = selectedOption ? selectedOption.label : "";
		setUserSubsidiarySelected({ ...userSubsidiarySelected, label: (subsidiaryLabel), value: subsidiaryKey });
	}
	const onResponseChange = (event) => {
		//console.log(event.target + "  " + event.target.name + " " + event.target.checked);
		const { name, id } = event.target;
		//event.preventDefault();
		//event.stopPropagation();
		if (name.startsWith("canRead_")) {
			setIsCanRead(event.target.checked);
		} else if (name.startsWith("canWrite_")) {
			setIsCanWrite(event.target.checked);
		} else if (name.startsWith("canReview_")) {
			setIsCanReview(event.target.checked);
		}
	}

	function submitComplete() {
		setIsSubmit(false);
		setIsCanRead(false);
		setIsCanWrite(false);
		setIsCanReview(false);
		setAppSurveySelected({name: "appSurveyKey", label: "", value: 0});
		setUserSubsidiarySelected({name: "subsidiaryKey", label: "", value: 0});
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			subsidiaryCompanyId: userSubsidiarySelected.value,
			appSurveyKey: appSurveySelected.value,
			canRead: canReadRef.current.checked,
			canWrite: canWriteRef.current.checked,
			canReview: canReviewRef.current.checked,
		};

		if (!appSurveySelected.value || appSurveySelected.value === 0) {
			setError(t("error.appSurveyNameReqd"));
			setIsSubmit(false);
		} else if(!userSubsidiarySelected.value || userSubsidiarySelected.value === 0){
			setError(t("error.subsidiaryReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
		setIsCanRead(false);
		setIsCanWrite(false);
		setIsCanReview(false);
		setAppSurveySelected({name: "appSurveyKey", label: "", value: 0});
		setUserSubsidiarySelected({name: "subsidiaryKey", label: "", value: 0});
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{userSubsidiaryLoaded ? <Select
					name="subsidiaryKey"
					options={subsidiaryOptions}
					onChange={subsidiaryHandler}
					placeholder={""}
					value={userSubsidiarySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="subsidiaryKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{appSurveyLoaded ? <Select
					name="appSurveyKey"
					options={appSurveyOptions}
					onChange={appSurveyHandler}
					placeholder={""}
					value={appSurveySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="appSurveyKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input type="checkbox" className="mycheckbox"
					ref={canReadRef}
					name={"canRead_0"}
					id={"canRead_0"}
					defaultChecked={true}
					checked={isCanRead}
					onChange={onResponseChange}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input type="checkbox" className="mycheckbox"
					ref={canWriteRef}
					name={"canWrite_0"}
					id={"canWrite_0"}
					defaultChecked={true}
					checked={isCanWrite}
					onChange={onResponseChange}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input type="checkbox" className="mycheckbox"
					ref={canReviewRef}
					name={"canReview_0"}
					id={"canReview_0"}
					defaultChecked={true}
					checked={isCanReview}
					onChange={onResponseChange}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(appSurveyOptions && appSurveyOptions.length > 0 && subsidiaryOptions && subsidiaryOptions.length > 0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
			</td>
		</tr>
	)

}
export default SubsidiaryAppSurveyTableRow;